"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.handleUserUnauthenticated = handleUserUnauthenticated;
exports.logout = exports.resetPassword = exports.forgotPassword = exports.signup = exports.refreshToken = exports.loginOTP = exports.login = exports.activateAccount = exports.ACTIONS = void 0;

var _ = require(".");

var _spec = require("./spec");

var _effects = require("redux-saga/effects");

var _utils = require("../utils");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(handleUserUnauthenticated);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  pendingRequests: 0,
  isLoading: false,
  accountActivated: null,
  data: {},
  errors: {},
  fieldErrors: {},
  nonFieldErrors: {}
};
var ACTIONS = {
  ACTIVATE_ACCOUNT: new _.APIAction('ACTIVATE_ACCOUNT'),
  LOGIN: new _.APIAction('LOGIN'),
  LOGIN_OTP: new _.APIAction('LOGIN_OTP'),
  REFRESH_TOKEN: new _.APIAction('REFRESH_TOKEN'),
  SIGNUP: new _.APIAction('SIGNUP'),
  FORGOT_PASSWORD: new _.APIAction('FORGOT_PASSWORD'),
  RESET_PASSWORD: new _.APIAction('RESET_PASSWORD'),
  LOGOUT: new _.Action('LOGOUT')
};
exports.ACTIONS = ACTIONS;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentPendingRequests;

  switch (action.type) {
    case ACTIONS.ACTIVATE_ACCOUNT.main:
    case ACTIONS.LOGIN.main:
    case ACTIONS.LOGIN_OTP.main:
    case ACTIONS.SIGNUP.main:
    case ACTIONS.FORGOT_PASSWORD.main:
    case ACTIONS.RESET_PASSWORD.main:
      currentPendingRequests = state.pendingRequests + 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        fieldErrors: {},
        nonFieldErrors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.LOGIN.success:
    case ACTIONS.LOGIN_OTP.success:
    case ACTIONS.SIGNUP.success:
    case ACTIONS.FORGOT_PASSWORD.success:
    case ACTIONS.RESET_PASSWORD.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        fieldErrors: {},
        nonFieldErrors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.ACTIVATE_ACCOUNT.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        accountActivated: true,
        errors: {},
        fieldErrors: {},
        nonFieldErrors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.ACTIVATE_ACCOUNT.fail:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        accountActivated: false,
        isLoading: currentPendingRequests > 0,
        errors: {},
        fieldErrors: {},
        nonFieldErrors: {}
      });

    case ACTIONS.LOGIN.fail:
    case ACTIONS.LOGIN_OTP.fail:
    case ACTIONS.SIGNUP.fail:
    case ACTIONS.FORGOT_PASSWORD.fail:
    case ACTIONS.RESET_PASSWORD.fail:
      currentPendingRequests = state.pendingRequests - 1;
      var splitedErrors = (0, _utils.splitErrors)(action.payload);
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: action.payload,
        fieldErrors: splitedErrors.fieldErrors,
        nonFieldErrors: splitedErrors.nonFieldErrors,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.LOGOUT.main:
      return initialState;

    default:
      return state;
  }
}

var activateAccount = function activateAccount(data) {
  return {
    type: ACTIONS.ACTIVATE_ACCOUNT.main,
    payload: {
      request: {
        url: _spec.AUTH_ENDPOINTS.ACTIVATE_ACCOUNT,
        method: 'POST',
        data: data
      }
    }
  };
};

exports.activateAccount = activateAccount;

var login = function login(data) {
  return {
    type: ACTIONS.LOGIN.main,
    payload: {
      request: {
        url: _spec.AUTH_ENDPOINTS.LOGIN,
        method: 'POST',
        data: data
      }
    }
  };
};

exports.login = login;

var loginOTP = function loginOTP(data) {
  return {
    type: ACTIONS.LOGIN_OTP.main,
    payload: {
      request: {
        url: _spec.AUTH_ENDPOINTS.LOGIN_OTP,
        method: 'POST',
        data: data
      }
    }
  };
};

exports.loginOTP = loginOTP;

var refreshToken = function refreshToken(data) {
  return {
    type: ACTIONS.REFRESH_TOKEN.main,
    payload: {
      request: {
        url: _spec.AUTH_ENDPOINTS.REFRESH_TOKEN,
        method: 'POST',
        data: data
      }
    }
  };
};

exports.refreshToken = refreshToken;

var signup = function signup(data) {
  return {
    type: ACTIONS.SIGNUP.main,
    payload: {
      request: {
        url: _spec.AUTH_ENDPOINTS.SIGNUP,
        method: 'POST',
        data: data
      }
    }
  };
};

exports.signup = signup;

var forgotPassword = function forgotPassword(data) {
  return {
    type: ACTIONS.FORGOT_PASSWORD.main,
    payload: {
      request: {
        url: _spec.AUTH_ENDPOINTS.FORGOT_PASSWORD,
        method: 'POST',
        data: data
      }
    }
  };
};

exports.forgotPassword = forgotPassword;

var resetPassword = function resetPassword(data) {
  return {
    type: ACTIONS.RESET_PASSWORD.main,
    payload: {
      request: {
        url: _spec.AUTH_ENDPOINTS.RESET_PASSWORD,
        method: 'POST',
        data: data
      }
    }
  };
};

exports.resetPassword = resetPassword;

var logout = function logout() {
  return {
    type: ACTIONS.LOGOUT.main
  };
};

exports.logout = logout;

function handleUserUnauthenticated() {
  return regeneratorRuntime.wrap(function handleUserUnauthenticated$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(logout());

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}